import React, { ReactNode } from "react";
import {
  defaultBrandsConfig,
  BrandsConfigContext,
  brandsConfig,
} from "utils/v2/BrandsConfig/BrandsConfigContext";

export const BrandsConfigProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const hostname = window.location.hostname;
  const brandConfig = brandsConfig[hostname] || defaultBrandsConfig;

  return (
    <BrandsConfigContext.Provider value={brandConfig}>
      {children}
    </BrandsConfigContext.Provider>
  );
};
